import { Menu, Product, ProductChoiceGroup, Stock } from './../restaurant-manager.models';
import {Injectable} from '@angular/core';
import {ApiService} from './api.service';
import {Category, Order, Tag, VatRate} from '../restaurant-manager.models';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {HttpClient, HttpHeaders} from '@angular/common/http';

export interface MenuDataInterface {
    categories: Category[];
    menus: Menu[];
    products: Product[];
    choices: ProductChoiceGroup[];
    stocks: Stock[];
}

@Injectable({
    providedIn: 'root'
})
export class SyncService {

    constructor(
        private apiService: ApiService,
        private http: HttpClient
    ) {}

    syncTags(): Observable<Tag[]> {
        return this.apiService.get<Tag[]>('/tags', true).pipe(map((tags: any[]) => {
            return tags.map(t => new Tag(t));
        }));
    }

    syncVats(): Observable<VatRate[]> {
        return this.apiService.get<VatRate[]>('/vats', true).pipe(map((vats: any[]) => {
            return vats.map(t => new VatRate(t));
        }));
    }

    syncCategories(restaurantId: string): Observable<Category[]> {
        return this.apiService.get<Category[]>('/sync/restaurants/' + restaurantId + '/categories', true).pipe(map((categories: any[]) => {
            return categories.map(c => new Category(c));
        }));
    }

    async syncMenu(restaurantId: string, filterBy: 'menu' | 'pos' | 'web' = null): Promise<MenuDataInterface> {
        const filter = filterBy ? '?filter='+ filterBy : '';
        let [categories, menus, products, choices, stocks] = await Promise.all([
            this.apiService.get<Category[]>('/sync2/restaurants/' + restaurantId + '/categories' + filter, true).toPromise(),
            this.apiService.get<Menu[]>('/sync2/restaurants/' + restaurantId + '/menus' + filter, true).toPromise(),
            this.apiService.get<Product[]>('/sync2/restaurants/' + restaurantId + '/products' + filter, true).toPromise(),
            this.apiService.get<ProductChoiceGroup[]>('/sync2/restaurants/' + restaurantId + '/choices', true).toPromise(),
            this.apiService.get<Stock[]>('/sync2/restaurants/' + restaurantId + '/stocks', true).toPromise()
        ]);
        // Map entities
        categories = categories.map(c => new Category(c));
        menus = menus.map(m => new Menu(m));
        products = products.map(p => new Product(p));
        choices = choices.map(c => new ProductChoiceGroup(c));
        stocks = stocks.map(s => new Stock(s));
        // Rebuild products with originCategory
        for (const p of products) {
            const c = categories.find(c => c.id === p.category);
            if (c) {
                p.originCategory = new Category({
                    id: c.id,
                    slug: c.slug,
                    name: c.name,
                    productionPriority: c.productionPriority
                });
            }
        }
        return {
            categories,
            menus,
            products,
            choices,
            stocks
        };
    }

    syncOrders(orders: Order[], restaurantId: string): Observable<Order[]> {
        return this.apiService.post<Order[]>('/sync/restaurants/' + restaurantId + '/orders', orders, true).pipe(map((orders: Order[]) => {
            return orders.map(o => new Order(o));
        }));
    }

    getSessionUploadParameters(sessionId: string): Observable<any> {
        return this.apiService.get<any>('/sync/sessions/' + sessionId + '/upload-url', true).pipe(map((result: any) => {
            return result;
        }));
    }

    uploadSession(url: string, data: any): Observable<Order> {
        let headers = new HttpHeaders();
        headers = headers.append('Content-Type', 'multipart/form-data');
        return this.http.put<any>(url, data, {headers});
    }
}
